import { createUseStyles } from 'react-jss';

const styles = {
  contentWrapper: {
    margin: '0 auto',
    maxWidth: ' 109.6rem',
    position: 'relative',
    minHeight: '20rem',
    marginBottom: '4rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
